import { useRef } from 'react';
import { getIsClient } from '../../utils/getIsClient';

export const useOnceBeforeRenderOnClient = (callback: () => void) => {
    const isClient = getIsClient();

    const hasRunRef = useRef(false);
    if (isClient && !hasRunRef.current) {
        hasRunRef.current = true;
        callback();
    }
};
